import React, { useState } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import { useNavigate } from 'react-router-dom';
import { apiConstants } from '../_constants';
import { isEnglish } from '../_helpers';
import { isNotExpired } from '../_services/misc.service';
import { topicService } from '../_services/topic.service';
import { SubscriptionModal } from '../Subscription/SubscriptionModal';

export const TopicBox = ({ topic, subscriptionData }) => {
  const navigate = useNavigate();
  const [topicData, setTopicData] = useState(topic);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const percentage = topic?.progress?.[0]?.percentage;
  const addBookmarks = async (data) => {
    let bookMarkQuery = {
      course_id: data.course_id,
      topic_id: data._id,
      subject_id: data.subject_id,
    };
    if (data?.bookmark?._id) {
      // checking if bookmark for topic already exist
      bookMarkQuery._id = data?.bookmark?._id;
      if (data?.bookmark?.bookmark) {
        bookMarkQuery.bookmark = false;
      } else {
        bookMarkQuery.bookmark = true;
      }
    } else {
      bookMarkQuery.bookmark = true;
    }
    bookMarkQuery.status = 1;

    topicService.bookmarkAdd(bookMarkQuery).then(
      (res) => {
        if (res?.data?._id) {
          setTopicData((prev) => ({ ...prev, bookmark: res?.data }));
        }
      },
      (err) => {
        // if (err == "Your Account has been deactivated") {
        //   setError(err);
        //   setLogoutVisible(true);
        // }
        console.error(err);
      },
    );
  };

  const checkSubscription = (item) => {
    let notExpired = isNotExpired(item?.expiry_date);

    if (
      !item?.is_paid ||
      (item?.is_paid && item?.isSubscribe && item?.payment_status == 1 && notExpired)
    ) {
      return true;
    } else {
      return false;
    }
  };



  const isTopicEnglish = isEnglish(topicData?.topic_name);

  return (
    <div className={'topicbox ' + (isTopicEnglish ? 'ltrtext' : 'rtltext')}>
      {!topicData?.is_paid && <div className='freelabel'>Free</div>}
      <div className='topiccontainer'>
        <img
          src={topicData?.image ? apiConstants.imgUrl + topicData?.image : '/img/subjectdummy.jpeg'}
          className='topiclistimg'
          style={{ alignSelf: 'flex-start' }}
        />
        <div>
          <div className='topiclisthead'>{topicData?.topic_name}</div>
          <div className='descitem'>
            Questions
            <img src='/img/question_icon.png' className='desc_icon' /> {topicData?.totalQuestions}{' '}
          </div>
          {percentage == 0 ||
            (percentage && topicData?.isactive == 1 && (
              <div className='completedlbl'>!Completed</div>
            ))}
        </div>
        {(!!percentage || (percentage == 0 && topicData?.isactive == 1)) && (
          <div className='progresscontainertopic'>
            <CircularProgressbar value={percentage} text={`${percentage}%`} />
          </div>
        )}
      </div>
      <div className='topicactions'>
        {checkSubscription(topicData) ? (
          <div className='d-flex gap-2'>
            <div
              className={'takestestbtn ' + (topicData?.totalQuestions == 0 ? 'Unavilable' : '')}
              onClick={() => {
                if (topicData?.totalQuestions > 0) {
                  if (!!percentage || percentage == 0) {
                    navigate('/exam', { state: { topic, mode: 1, attempt: 2 } });
                  } else {
                    navigate('/exam', { state: { topic, mode: 1, attempt: 1 } });
                  }
                }
              }}
            >
              {!!percentage || percentage == 0 ? 'Re-Take Test' : 'Take Test'}{' '}
            </div>

            <div
              className={'practicebtn ' + (topicData?.totalQuestions == 0 ? 'Unavilable' : '')}
              onClick={() => {
                if (topicData?.totalQuestions > 0) {
                  navigate('/exam', { state: { topic, mode: 2, attempt: 1 } });
                }
              }}
            >
              Practice
            </div>
          </div>
        ) : (
          <div className='d-flex gap-2'>
            <div
              className={'subscribebtn ' + (!subscriptionData?._id ? 'Unavilable' : '')}
              onClick={() => {
                if (subscriptionData?._id) {
                  setShowSubscriptionModal(true);
                }
              }}
            >
              {!subscriptionData?._id ? 'Unavilable' : 'Subscribe Topic'}
            </div>
          </div>
        )}
        <div
          className='bookmark'
          onClick={() => {
            addBookmarks(topicData);
          }}
        >
          <img
            src={topicData?.bookmark?.bookmark ? '/img/bookmark_filled.png' : '/img/bkmark.png'}
            className='bookmarkicon'
          />
        </div>
      </div>
      <SubscriptionModal
        setShowModal={setShowSubscriptionModal}
        showModal={showSubscriptionModal}
        data={topicData}
        subscriptionData={subscriptionData}
        type={'Course'}
      />
    </div>
  );
};
